import React from "react";
import { Zoom } from "react-reveal";
import { useNavigate } from "react-router-dom";

const MaintenanceSearch = ({ item, room_uuid }) => {
  const navigate = useNavigate();

  return (
    <div id={item.name} key={item.id}>
      <Zoom>
        <div
          className="con-img-container v3"
          onClick={() =>
            navigate(`/${room_uuid}/maintenance/companies/${item.company_uuid}`)
          }
        >
          <div className="con-img">
            <img src={item.image} alt="" />
            <p></p>
          </div>
        </div>
        <div className="con-text-container">
          <p>{item.name}</p>
          <hr className="mb-0 dark" />
        </div>
      </Zoom>
    </div>
  );
};

export default MaintenanceSearch;
